var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-response text--primary text-body-1"},[_vm._v(_vm._s(_vm.text)+" "),(_vm.isTyping)?_c('span',{staticClass:"cursor-wrapper"},[_c('span',{staticClass:"cursor-label"},[_c('v-icon',{staticClass:"ai",attrs:{"size":"small"}},[_vm._v(" mdi-creation ")]),_vm._v(" Claudia ")],1),_c('span',{staticClass:"cursor"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }